import type { LDContext } from 'launchdarkly-js-client-sdk'
import { initialize } from 'launchdarkly-js-client-sdk'
import env from '~/env'

const context: LDContext = {
  kind: 'org',
  key: env.VITE_LAUNCH_DARKLY_PROJECT_KEY,
}

const client = initialize(env.VITE_LAUNCH_DARKLY_CLIENT_ID, context, {
  sendEvents: !import.meta.env.DEV,
  evaluationReasons: true,
})

export default client
